module.exports = __webpack_public_path__ + "static/logo2-0a7ac875bc9d6b0494de6c9a7d532e64.png";